import React, { useEffect, useRef, useState } from 'react'
import ToastService from '../../../../../../../services/toastService/ToastService';
import FormCreator from '../../../../../../../components/finalForms/FormCreator';
import Buttons from '../../../../../../../components/ui/button/Buttons';
import { importContractScopes } from './ImportContractScope.formfield.config';
import { useImportContractScopesMutation, useUpdateCostFromScopesForAllDepartmentsMutation } from '../../../../../../../app/services/contractAPI';

const ImportContractScopes = ({ onClose, onSuccess,contractId }) => {
    const formRef = useRef();
    const [formData, setFormData] = useState(importContractScopes);

    const [ContractScopes, {
        isLoading: isImporting,
        isSuccess: isImported,
        data: importData
    }] = useImportContractScopesMutation();

    const [updateCostFromScopesForAllDepartments] = useUpdateCostFromScopesForAllDepartmentsMutation();

    const resetForm = () => {
        const form = { ...importContractScopes }
        form.initialState = { ...importContractScopes.initialState };
        setFormData(form);
    }

    const handleCloseClick = () => {
        resetForm();
        onClose();
    }

    const handleSaveClick = () => {

        const formData = formRef.current.getFormData();
        if (formData?.scopesImportFile) {
            const file = formData.scopesImportFile[0].base64Data;
            const base64Data = file.split(",")[1];
            const req = {
                base64File: base64Data
            }
            ContractScopes(req);
        }
    }

    useEffect(() => {
        if (isImported && importData) {
            if (importData?.message?.includes("Missing required")) {
                ToastService.error(importData?.message)
            }
            else {
                ToastService.success(importData?.message);
                updateCostFromScopesForAllDepartments(contractId)
            }
            onSuccess();
        }
    }, [isImported, importData]);

    return (
        <div className='col-md-12'>
            <div className='row'>
                <FormCreator
                    ref={formRef}
                    config={formData}
                />
                <div className='d-flex mt-2 justify-content-center'>
                    <Buttons
                        buttonText="Cancel"
                        buttonTypeClassName="btn secondary-btn"
                        onClick={handleCloseClick}
                    />
                    <Buttons
                        buttonText="Import"
                        buttonTypeClassName="btn blue-btn w-full ml-2"
                        onClick={handleSaveClick}
                        isLoading={isImporting}
                    />
                </div>
            </div>
        </div>
    )
}
export default ImportContractScopes